import styled from 'styled-components'
import DoneIcon from '@mui/icons-material/Done'
import BackspaceOutlinedIcon from '@mui/icons-material/BackspaceOutlined'

export default function NumpadComponent({
  clickFunc,
  clickSound,
  submitVisible = false,
  submitDisabled = true,
  submitFunction = () => null,
  backVisible,
  backDisabled,
  backFunction = () => null,
  containerStyles = {},
}) {
  async function handleClick(num) {
    if (clickSound) {
      const soundModule = await import('src/assets/audio/chat_tick.mp3')
      const sound = new Audio(soundModule.default)
      sound.play()
    }
    clickFunc(num)
  }

  return (
    <div className="d-flex flex-column" style={{ gap: '12px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-around', gap: '12px', ...containerStyles }}>
        <NumPadButton onClick={() => handleClick(1)}>1</NumPadButton>
        <NumPadButton onClick={() => handleClick(2)}>2</NumPadButton>
        <NumPadButton onClick={() => handleClick(3)}>3</NumPadButton>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-around', gap: '12px', ...containerStyles }}>
        <NumPadButton onClick={() => handleClick(4)}>4</NumPadButton>
        <NumPadButton onClick={() => handleClick(5)}>5</NumPadButton>
        <NumPadButton onClick={() => handleClick(6)}>6</NumPadButton>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-around', gap: '12px', ...containerStyles }}>
        <NumPadButton onClick={() => handleClick(7)}>7</NumPadButton>
        <NumPadButton onClick={() => handleClick(8)}>8</NumPadButton>
        <NumPadButton onClick={() => handleClick(9)}>9</NumPadButton>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-around', gap: '12px', ...containerStyles }}>
        <NumPadButton
          className="backspace-btn"
          disabled={backDisabled}
          onClick={() => backFunction('DL')}
        >
          <BackspaceOutlinedIcon style={{ fontSize: '20px', margin: 0 }} />
        </NumPadButton>
        <NumPadButton onClick={() => handleClick(0)}>0</NumPadButton>
        {submitVisible && (
          <NumPadButton
            className={submitDisabled ? 'submit-disabled' : 'submit-enabled'}
            disabled={submitDisabled}
            onClick={() => submitFunction && submitFunction()}
          >
            <DoneIcon style={{ margin: '0', fontSize: '24px' }} />
          </NumPadButton>
        )}
      </div>
    </div>
  )
}

const NumPadButton = styled.button`
  flex: 1;
  font-size: 24px;
  font-weight: 600;
  aspect-ratio: 1;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.9);
  border: 2px solid rgba(150, 150, 200, 0.2);
  color: #5a67d8;
  transition: all 0.2s ease;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(150, 150, 200, 0.15);
  
  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 1);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(90, 103, 216, 0.25);
    border-color: rgba(90, 103, 216, 0.4);
  }
  
  &:active:not(:disabled) {
    transform: translateY(0px);
    box-shadow: 0 2px 6px rgba(90, 103, 216, 0.2);
    background: rgba(184, 198, 245, 0.3);
  }
  
  &.backspace-btn {
    background: rgba(255, 255, 255, 0.8);
    color: #718096;
    
    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
    
    &:hover:not(:disabled) {
      color: #e53e3e;
      background: rgba(255, 220, 220, 0.6);
      border-color: rgba(229, 62, 62, 0.3);
    }
  }
  
  &.submit-enabled {
    background: linear-gradient(135deg, #5a67d8 0%, #7c3aed 100%);
    color: #fff;
    font-weight: 700;
    border: none;
    
    &:hover {
      background: linear-gradient(135deg, #4c51bf 0%, #6b21a8 100%);
      box-shadow: 0 4px 16px rgba(90, 103, 216, 0.4);
    }
    
    &:active {
      transform: scale(0.95);
    }
  }
  
  &.submit-disabled {
    background: rgba(200, 200, 200, 0.5);
    color: rgba(255, 255, 255, 0.7);
    border: none;
    cursor: not-allowed;
    opacity: 0.6;
  }
  
  &:disabled {
    cursor: not-allowed;
  }
`
